import type { GQL_ID } from '@@partner:types:graphql'
import type { ProductReviewInfo } from '@@partner:types:app'

import { gql, useQuery } from '@apollo/client'

import { PRODUCT_REVIEW_FIELDS } from '@@partner:graphql/shortcuts'

export interface SingleProductReviewQuery {
  productReview: ProductReviewInfo
}
export interface SingleProductReviewQueryVariables {
  id?: GQL_ID
}

export const GQL_QUERY_SINGLE_PRODUCT_REVIEW = gql`
  query (
    $id: ID!
  ) {
    productReview: singleProductReview(id: $id) {
      ${PRODUCT_REVIEW_FIELDS}
      customer {
        id
        first_name
        last_name
      }
      product {
        id
        name
        preview {
         url
        }
      }
    }
  }
`

export const useFetchSingleProductReview = (
  variables: SingleProductReviewQueryVariables
) =>
  useQuery<SingleProductReviewQuery, SingleProductReviewQueryVariables>(
    GQL_QUERY_SINGLE_PRODUCT_REVIEW,
    {
      variables,
      skip: !variables.id
    }
  )
